<template>
  <div v-if="tableFieldsDefinition" class="text-left">
    <b-form-group :label="$gettext('Customize columns visibility and column order')">
      <hr class="bg-white mt-0 mb-1">
      <draggable
        tag="div"
        v-model="fields"
        v-bind="dragOptions"
        @start="drag = true"
        @end="drag = false"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <div class="d-flex align-items-baseline" v-for="(element) in fields" :key="element.key">
            <b-form-checkbox
              class="flex-grow-1 "
              :value="true"
              :unchecked-value="false"
              v-model="element.visible"
            >
              {{ element.label }}
            </b-form-checkbox>
            <font-awesome-icon icon="grip-horizontal" class="handler" />
          </div>
        </transition-group>
      </draggable>
    </b-form-group>
    <div class="text-center">
      <b-badge class="cursor-pointer" @click="resetFields" @keydown.enter="resetFields" role="button" v-translate>
        Reset Fields
      </b-badge>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import ListMixin from '../../mixins/list.mixin'

export default {
  emits: ['refresh-fields'],
  name: 'ApiListFieldsCustomization',
  components: {
    Draggable
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fields: [],
      fieldsOptions: [],
      drag: false
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  watch: {
    fields: {
      handler (val) {
        val = val.map((x, i) => {
          x.order = i
          return x
        })
        if (val.length > 0 && this.type) {
          const tableFields = this.getLocalStorage('tableFields') || {}
          tableFields[this.type] = val
          this.setLocalStorage('tableFields', tableFields)
          this.$emit('refresh-fields')
        }
      },
      deep: true
    }
  },
  mixins: [ListMixin],
  mounted () {
    // this.fieldsOptions = this.getLocalStorage('tableFields') && this.getLocalStorage('tableFields')[this.type] ? this.getLocalStorage('tableFields')[this.type].filter(x => x.key !== 'actions').map(x => ({text: x.label || this.snakeCaseToTitleCase(this.camelCaseToTitleCase(x.key)), value: x.visible})) : this.tableFieldsDefinition.filter(x => x.key !== 'actions').map(x => ({text: x.label || this.snakeCaseToTitleCase(this.camelCaseToTitleCase(x.key)), value: true}))
    this.fields = this.getLocalStorage('tableFields') && this.getLocalStorage('tableFields')[this.type] ? this.getLocalStorage('tableFields')[this.type] : this.tableFieldsDefinition.filter(x => x.key !== 'actions').map((x, i) => ({ key: x.key, label: x.label || this.snakeCaseToTitleCase(this.camelCaseToTitleCase(x.key)), visible: true, order: i }))
  },
  methods: {
    resetFields() {
      this.fields = this.tableFieldsDefinition.filter(x => x.key !== 'actions').map((x, i) => ({ key: x.key, label: x.label || this.snakeCaseToTitleCase(this.camelCaseToTitleCase(x.key)), visible: true, order: i }))
    }
  }
}
</script>

<style lang="scss">
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  color: #000;
}
.handler {
  cursor: ns-resize
}
</style>
